import React, { useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { HelpOutline } from '@mui/icons-material';
import HelpCenter from './HelpCenter';

const HelpButton = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Tooltip title="Help Center">
        <IconButton
          onClick={() => setOpen(true)}
          sx={{
            color: '#b8860b',
            bgcolor: 'rgba(255, 215, 0, 0.12)',
            border: '1px solid',
            borderColor: 'rgba(255, 193, 7, 0.3)',
            width: 32,
            height: 32,
            '&:hover': {
              bgcolor: 'rgba(255, 215, 0, 0.22)',
              borderColor: '#ffc107',
              color: '#996515',
            },
          }}
        >
          <HelpOutline sx={{ fontSize: 18 }} />
        </IconButton>
      </Tooltip>
      <HelpCenter open={open} onClose={() => setOpen(false)} />
    </>
  );
};

export default HelpButton;
